var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBankPayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#DEDFE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4902 8.05714L18.4311 7.13407V15.8637L15.4902 16.8659V8.05714ZM11 18H23V6H11.0263V18H11Z",
    fill: "#400700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBankPayment);
export default __webpack_public_path__ + "static/media/icon-bank-payment.e5469d99697a4164bce7182d426fd254.svg";
export { ForwardRef as ReactComponent };